import { Component, Input, OnInit } from '@angular/core';

import * as _ from 'lodash';
import * as d3 from 'd3';

import { StateService } from '@uirouter/angular';
import { ProjectService } from '../../../../services/project.service';
import { GfTranslateService } from '../../../../services/core.translate.service';
import { UiService } from '../../../../services/core.ui.service';
import { ProjectReportsData } from '../../services/project.reports.data.service';

import { gfDateFunction } from '../../../../pipes/date/date.functions';
@Component({
    selector: 'project-disk-report',
    template: require('./project.report.disk.component.html')
})
export class ProjectDiskReportComponent implements OnInit {

    @Input() project: any = null;

    protected charts: any = false;
    protected dateChartOptions: any;
    protected sourceChartOptions: any;
    private rangeDate: any;
    protected chartDaysText;
    private chartDays;

    constructor(
        private stateService: StateService,
        private projectService: ProjectService,
        private gfTranslateService: GfTranslateService,
        private uiService: UiService,
        private projectReportsData: ProjectReportsData,
    ) { }

    ngOnInit() {
        this.dateChartOptions = {
            chart: {
                type: 'lineChart',
                height: 350,
                margin: {
                    top: 20,
                    right: 30,
                    bottom: 65,
                    left: 65
                },
                showLegend: false,
                noData: this.gfTranslateService.translate("No Data Available"),
                color: ['#99CC33'],
                x: function (d) {
                    return d.x;
                },
                y: function (d) {
                    return d.y;
                },
                lines: {
                    xScale: d3.time.scale()
                },
                xAxis: {
                    axisLabel: this.gfTranslateService.translate("Date"),
                    rotateLabels: -30,
                    tickFormat: function (d) {
                        return gfDateFunction(new Date(d), 'L');
                    }
                },
                yAxis: {
                    axisLabel: this.gfTranslateService.translate("Usage in MB"),
                    tickFormat: function (d) {
                        var ret = parseInt(d);
                        return ret;
                    }
                },
                tooltip: {
                    valueFormatter: function (d) {
                        return d + ' MB';
                    }
                }
            }
        };

        this.sourceChartOptions = {
            chart: {
                type: 'pieChart',
                height: 360,
                noData: this.gfTranslateService.translate("No Data Available"),
                x: function (d) { return d.key; },
                y: function (d) { return d.y; },
                valueFormat: d3.format(".0f"),
                transitionDuration: 200,
                showLabels: false,
                labelThreshold: 0.01,
                showLegend: true,
                legendPosition: 'bottom',
                tooltip: {
                    valueFormatter: function (d) {
                        return d + ' MB';
                    }
                }
            }
        };

        const stateParams = this.stateService.params;

        this.rangeDate = decodeURIComponent(_.get(stateParams, 'rangeDate', ''));
        this.setChartDaysData(this.rangeDate);
        this.refreshData();
    }

    updateRangeDate(newRange) {
        var opts = { reload: false, location: true, notify: false };

        this.stateService.go('.', { rangeDate: newRange }, opts)
            .then(this.refreshData, this.refreshData);
    }

    refreshData = () => {
        this.charts = false;

        this.projectService.report(this.getParams())
            .then(
                (response) => {
                    this.charts = this.getChartData(_.get(response, 'items', {}));
                },
                () => {
                    this.charts = {};
                    var msg = this.gfTranslateService.translate(
                        'There was a problem loading disk usage data for {{unixName}}',
                        this.stateService.params
                    );
                    this.uiService.message.showWarning(msg, 'Data Error');
                }
            );
    }

    downloadData(format) {
        this.projectReportsData.runReport(this.getParams(), format);
    };

    isSelected = _.memoize((val) => {
        return val == this.rangeDate;
    });

    getParams() {
        return {
            rangeDate: this.rangeDate,
            project: this.stateService.params.unixName,
            type: this.stateService.params.type
        };
    }

    setChartDaysData(days) {
        if (days !== '') {
            var daysValue = (_.split(days, ' ')[0]).replace("-", "");
            this.chartDaysText = this.gfTranslateService.translate("Last {{days}} days", { days: daysValue });
            this.chartDays = '-' + daysValue + ' days';
        } else {
            this.chartDaysText = this.gfTranslateService.translate("All time");
            this.chartDays = '';
        }
    }

    getChartData(items) {
        var ret = {
            dateChartData: null,
            sourceChartData: null,
        };

        if (items.project) {
            ret.dateChartData = this.getDateChartData(items.project)
        }

        if (items.source) {
            ret.sourceChartData = this.projectReportsData.setPieChartData(
                _.map(
                    items.source,
                    function (row) {
                        row.quantity = Math.round(( (parseInt(row.quantity) + 1) / 1024) / 1024);
                        return row;
                    }
                )
            );
        }

        return ret;
    }

    getDateChartData(rows) {
        var vals = _.map(
            rows,
            function (row) {
                var dt = new Date(gfDateFunction(row.checkDate.date, 'L'));
                return {
                    x: new Date(dt.getTime() + (dt.getTimezoneOffset() * 60000)),
                    y: Math.round((parseInt(row.bytes) / 1024) / 1024)
                };
            }
        );

        return [
            {
                values: vals,
                area: true
            }
        ];
    }
}